var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMachinesblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Color",
    d: "M8,16a2.378,2.378,0,0,1-1.012-.225L1.3,13.134a2.212,2.212,0,0,1-1.3-2V4.852A2.105,2.105,0,0,1,.3,3.788a.048.048,0,0,0,0-.012.049.049,0,0,1,0-.012.042.042,0,0,1,.007-.01.052.052,0,0,0,.008-.01A1.738,1.738,0,0,1,.45,3.572l.008-.01.028-.034a.406.406,0,0,1,.059-.064,2.223,2.223,0,0,1,.761-.6L6.992.221a2.406,2.406,0,0,1,2.013,0L14.7,2.864a2.224,2.224,0,0,1,.76.6.4.4,0,0,1,.053.057l.027.032.026.033a1.6,1.6,0,0,1,.112.157l.007.008a.029.029,0,0,1,.008.01.04.04,0,0,1,0,.012.048.048,0,0,0,0,.01A2.114,2.114,0,0,1,16,4.851v6.295a2.218,2.218,0,0,1-1.307,1.989L9.007,15.776A2.38,2.38,0,0,1,8,16ZM14,5,9,7.639V14l4.742-2.5a.459.459,0,0,0,.258-.4ZM2,5v6.086a.456.456,0,0,0,.253.41L7,14V7.639ZM8,2a.69.69,0,0,0-.26.049L3,3.972,8,6l5-2.029L8.26,2.049A.69.69,0,0,0,8,2Z",
    transform: "translate(-4601 -3163)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(4601 3163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Color-2",
    "data-name": "Color",
    d: "M8,16a2.378,2.378,0,0,1-1.012-.225L1.3,13.134a2.212,2.212,0,0,1-1.3-2V4.852A2.105,2.105,0,0,1,.3,3.788a.048.048,0,0,0,0-.012.049.049,0,0,1,0-.012.042.042,0,0,1,.007-.01.052.052,0,0,0,.008-.01A1.738,1.738,0,0,1,.45,3.572l.008-.01.028-.034a.406.406,0,0,1,.059-.064,2.223,2.223,0,0,1,.761-.6L6.992.221a2.406,2.406,0,0,1,2.013,0L14.7,2.864a2.224,2.224,0,0,1,.76.6.4.4,0,0,1,.053.057l.027.032.026.033a1.6,1.6,0,0,1,.112.157l.007.008a.029.029,0,0,1,.008.01.04.04,0,0,1,0,.012.048.048,0,0,0,0,.01A2.114,2.114,0,0,1,16,4.851v6.295a2.218,2.218,0,0,1-1.307,1.989L9.007,15.776A2.38,2.38,0,0,1,8,16ZM14,5,9,7.639V14l4.742-2.5a.459.459,0,0,0,.258-.4ZM2,5v6.086a.456.456,0,0,0,.253.41L7,14V7.639ZM8,2a.69.69,0,0,0-.26.049L3,3.972,8,6l5-2.029L8.26,2.049A.69.69,0,0,0,8,2Z",
    transform: "translate(-4601 -3163)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachinesblack);
export default __webpack_public_path__ + "static/media/machinesblack.cb2a611b.svg";
export { ForwardRef as ReactComponent };